export default {
  tabLabel: 'Document Request',
  uploadPage: {
    heading: 'Upload page',
    subtitle:
      'The logo, title and description claimants see on the document upload page. A blank field uses the default.',
    titleLabel: 'Title',
    descriptionLabel: 'Description',
    logoLabel: 'Logo',
    logoAlt: 'Upload page logo',
    removeLogo: 'Remove logo',
    save: 'Save',
    retry: 'Retry',
  },
  shareTemplates: {
    heading: 'Customize document request message',
    subtitle: 'Edit the SMS and email a document request link is sent with',
    smsSectionTitle: 'SMS Message',
    emailSectionTitle: 'Email Message',
  },
};
